import _sumBy from "lodash/sumBy"
import _toNumber from "lodash/toNumber"
import { numberToReal } from "services/utils/mask"

export const sumOfValuesInObjectProperties = (object, property) => {
  return numberToReal(_sumBy(object, (item) => _toNumber(item[property])))
}



// WEBPACK FOOTER //
// ./src/services/utils/sumOfValuesInObjectProperties.js